<template>
  <div class="services-page">

    <!-- 第一部分：顶部大图 -->
    <section class="hero-section">
      <img src="@/assets/services/hero.png" alt="展示图" class="hero-image" />
    </section>

    <!-- 第二部分：图片卡片展示 -->
    <section class="gallery-section">
      <div class="content-wrapper">
        <h2 class="section-title">服&nbsp;&nbsp;&nbsp;&nbsp;务</h2>
        <div class="card-grid">
          <div v-for="(item, index) in galleryItems" :key="index" class="card">
            <img :src="item.img" :alt="'服务' + (index + 1)" class="card-image" />
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  data() {
    return {
      galleryItems: [
        { img: require('@/assets/services/soft.png') },
        { img: require('@/assets/services/app.png') },
        { img: require('@/assets/services/web.png') },
        { img: require('@/assets/services/mini-program.png') },
        { img: require('@/assets/services/technology-transfer.png') },
        { img: require('@/assets/services/technology-exchange.png') },
      ]
    }
  }
}
</script>

<style scoped>
.services-page {
  font-family: sans-serif;
  margin: 0;
  padding: 0;
}

/* 顶部大图部分 */
.hero-section {
  width: 100%;
  overflow: hidden;
  margin: 0;
  padding: 0;
}
.hero-image {
  width: 100%;
  height: auto;
  display: block;
}

/* 卡片展示部分 */
.gallery-section {
  padding: 2.5rem 0;
  text-align: center;
}

/* 限制宽度为 90vw 最大1200px并居中 */
.content-wrapper {
  max-width: 1200px;
  width: 90vw;
  margin: 0 auto;
}

.section-title {
  color: black;
  font-size: clamp(28px, 5vw, 35px);
  font-weight: bold;
  margin-bottom: 3rem;
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 默认3列 */
  gap: 3rem;
}

.card {
  background-color: transparent;
  border: none;          /* 去除边框 */
  box-shadow: none;      /* 去除阴影 */
  padding: 0;            /* 如需去除卡片内边距，可设置0 */
}

.card-image {
  width: 100%;
  display: block;
  height: auto;
  border: none;          /* 去除图片边框 */
  outline: none;         /* 去除聚焦时的轮廓线 */
  box-shadow: none;      /* 去除图片阴影 */
}


.card-description {
  margin-top: 0.625rem;
  font-size: 14px;
  color: #555;
}

/* 响应式调整 */

/* 中屏，tablet */
@media (max-width: 992px) {
  .card-grid {
    grid-template-columns: repeat(2, 1fr); /* 2列 */
  }
}

/* 小屏，mobile */
@media (max-width: 600px) {
  .content-wrapper {
    width: 95vw;
  }
  .card-grid {
    grid-template-columns: 1fr; /* 1列 */
  }
  .section-title {
    font-size: clamp(24px, 7vw, 36px);
  }
}
</style>
